export function initAnimations() {
    const frames = document.querySelectorAll('.frame:not(.frame-type-grid, .frame-layout-20)');

    createIntersectionObserver(frames, frame => {
        frame.classList.add('frame--visible');
    });
}

/**
 * @template T
 * @param {NodeListOf<T>} entries
 * @param {(T) => void} callback
 * @returns {IntersectionObserver}
 */
function createIntersectionObserver(entries, callback) {
    /** @type {HTMLElement[]} */
    const queue = [];

    let running = false;

    function _work(start = false) {
        if (running && start) {
            return;
        }

        running = true;

        if (queue.length === 0) {
            running = false;
            return;
        }

        callback(queue.shift());

        setTimeout(_work, 150);
    }

    const offset = window.innerWidth > 600 ? 150 : 50;

    const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
            if (!entry.isIntersecting) {
                continue;
            }

            queue.push(entry.target);
            _work(true);
            observer.unobserve(entry.target);
        }
    }, {
        rootMargin: `0px 0px -${offset}px 0px`,
        threshold: 0
    });

    for (const entry of entries) {
        observer.observe(entry);
    }

    return observer;
}
